import { render, staticRenderFns } from "./section2.vue?vue&type=template&id=3d3ee17a&scoped=true"
import script from "./section2.vue?vue&type=script&lang=js"
export * from "./section2.vue?vue&type=script&lang=js"
import style0 from "./section2.vue?vue&type=style&index=0&id=3d3ee17a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d3ee17a",
  null
  
)

export default component.exports